<script lang="ts" setup>
const route = useRoute()
const translation = 'eng'

useSeo({
  title: `Search & Explore Bible Books`,
  description: `Search & Explore Bible Books`,
})

const { data: books, status, error } = await useBibleBooks(translation)

if (error.value && error.value.statusCode === 404) {
  throw showError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
  })
}

const searchResultsBooks = computed(() => {
  if (!books.value) return []
  const query = Array.isArray(route.query.query) ? '' : route.query.query?.toLowerCase() || ''
  return books.value.filter((book) => book.title.toLowerCase().includes(query))
})

const oldTestamentBooks = computed(() => {
  if (!books.value) return []
  return books.value.filter((book) => book.testament === 'old').slice(0, 8)
})

const newTestamentBooks = computed(() => {
  if (!books.value) return []
  return books.value.filter((book) => book.testament === 'new').slice(0, 8)
})
</script>

<template>
  <div v-if="route.name === 'bible-translation' || route.name === 'bible'" class="md:space-y-12 space-y-6">
    <PageTitle :route="{ name: 'explore' }">Bible Books</PageTitle>

    <SearchInput />

    <ExploreNavigation />

    <section v-if="!Object.keys(route.query).length" class="space-y-5">
      <SectionTitle>Bible Translations</SectionTitle>

      <BibleTranslationList />
    </section>

    <template v-if="route.name === 'bible'">
      <section v-if="Object.keys(route.query).length" class="space-y-5">
        <BibleBookGrid v-if="searchResultsBooks.length" :books="searchResultsBooks" :status="status" />
        <div v-else class="text-center p-16 text-lg w-full">No results were found that match your criteria.</div>
      </section>

      <template v-else>
        <section class="space-y-5">
          <div class="flex flex-row justify-between items-baseline">
            <div class="text-lg">
              <NuxtLink :href="`/bible/${translation}/testament/old/`" class="hover:underline font-bold">
                <SectionTitle> Old Testament Books</SectionTitle>
              </NuxtLink>
            </div>
            <div>
              <TagLink :href="`/bible/${translation}/testament/old/`">
                <span>More</span>
              </TagLink>
            </div>
          </div>

          <BibleBookGrid :books="oldTestamentBooks" :status="status" />
        </section>

        <section class="space-y-5">
          <div class="flex flex-row justify-between items-baseline">
            <div class="text-lg">
              <NuxtLink :href="`/bible/${translation}/testament/new/`" class="hover:underline font-bold">
                <SectionTitle> New Testament Books</SectionTitle>
              </NuxtLink>
            </div>
            <div>
              <TagLink :href="`/bible/${translation}/testament/new/`">
                <span>More</span>
              </TagLink>
            </div>
          </div>

          <BibleBookGrid :books="newTestamentBooks" :status="status" />
        </section>
      </template>
    </template>

    <NuxtPage v-else />
  </div>

  <NuxtPage v-else />
</template>

<style scoped></style>
